import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Modal,
} from "rsuite";
import { ContractServices } from "../../../core/services/ContractServices";
import "./Contracts.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  displayAmountField,
  displayDateField,
  displayField,
  displayYesNo,
  downloadImage,
} from "../../../utils/helpers";

const ViewContract = (props: any) => {
  const { t } = useTranslation();
  const contractViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [contractInfo, setContractInfo] = useState<any>({});
  async function getViewContractDetail(id: number) {
    try {
      setLoader(true);
      const res = await ContractServices.viewContract(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setContractInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewContractDetail(contractViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
        size="md"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="contracts">
            <Container className="container">
              {contractInfo && Object.keys(contractInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <Form.Group controlId="contract_from">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("FROM")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(`${contractInfo?.contract_from}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_to">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("TO")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(`${contractInfo?.contract_to}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_for">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("FOR")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${contractInfo?.contract_for_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_last_active_contract">
                      <Form.ControlLabel>
                        {t("LAST")} {t("ACTIVE")} {t("CONTRACT")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${contractInfo?.is_last_active_contract}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="client_contract_type_name">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("TYPE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${contractInfo?.client_contract_type_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_billing_rate">
                      <Form.ControlLabel>
                        {t("BILLING")} {t("RATE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayAmountField(
                          `${contractInfo?.contract_billing_rate}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="bill_payment_frequency">
                      <Form.ControlLabel>
                        {t("BILLING")} {t("FREQUENCY")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${contractInfo?.bill_payment_frequency_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="automate_bill">
                      <Form.ControlLabel>
                        {t("AUTOMATE")} {t("BILL")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(`${contractInfo?.automate_bill}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="po_number">
                      <Form.ControlLabel>
                        {t("PO")} {t("NUMBER")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${contractInfo?.po_number}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="agreement_number">
                      <Form.ControlLabel>
                        {t("AGREEMENT")} {t("NUMBER")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${contractInfo?.agreement_number}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-1">
                      {t("LICENSE")} {t("DETAILS")}
                    </h5>
                    <Form.Group controlId="music_licenses_name">
                      <Form.ControlLabel>
                        {t("MUSIC")} {t("LICENSE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${contractInfo?.music_licenses_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_internal_ad_allowed">
                      <Form.ControlLabel>
                        {t("INTERNAL")} {t("AD")} {t("ALLOWED")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${contractInfo?.is_internal_ad_allowed}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_internal_ad_allowed">
                      <Form.ControlLabel>
                        {t("EXTERNAL")} {t("AD")} {t("ALLOWED")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${contractInfo?.is_external_ad_allowed}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_remarks">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("REMARKS")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${contractInfo?.contract_remarks}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    {contractInfo?.contract_file &&
                      contractInfo?.contract_file_url && (
                        <Form.Group controlId="contract_file">
                          <Form.ControlLabel>
                            {t("CONTRACT")} {t("FILE")}:
                          </Form.ControlLabel>
                          <Form.ControlLabel
                            onClick={() =>
                              downloadImage(
                                contractInfo?.contract_file_url,
                                contractInfo?.contract_file
                              )
                            }
                          >
                            <span className="Link">
                              {displayField(`${contractInfo?.contract_file}`)}
                            </span>
                          </Form.ControlLabel>
                        </Form.Group>
                      )}
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewContract;
